<p>
  weighed-product works!
</p>
